var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeguridad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.5C12.2091 1.5 14 2.84315 14 4.5V10.5H6V4.5C6 2.84315 7.79086 1.5 10 1.5ZM16 10.5V4.5C16 2.01472 13.3137 0 10 0C6.68629 0 4 2.01472 4 4.5V10.5C1.79086 10.5 0 11.8431 0 13.5V21C0 22.6569 1.79086 24 4 24H16C18.2091 24 20 22.6569 20 21V13.5C20 11.8431 18.2091 10.5 16 10.5ZM4 12H16C17.1046 12 18 12.6716 18 13.5V21C18 21.8284 17.1046 22.5 16 22.5H4C2.89543 22.5 2 21.8284 2 21V13.5C2 12.6716 2.89543 12 4 12Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguridad);
export default __webpack_public_path__ + "static/media/seguridad.cc9ecee1df420a313fdfe4c3df5e3071.svg";
export { ForwardRef as ReactComponent };